module.exports = __webpack_public_path__ + "img/pc_channel_product_col5_1.jpg";